module.exports = "https://sf6-scmcdn2-tos.pstatp.com/motor/pc/_next/static/images/selected-dafault-d42c3970a15d4f494c41b26e26ca4e96.png";